import React from 'react';
import { Navigate  } from 'react-router-dom';

import DashboardLayout from './components/layouts/dashboard/DashboardLayout';
import MainLayout from './components/layouts/main/MainLayout';

import Login from './components/pages/Login';
import NotFound from './components/pages/NotFound';
import StartingPage from './components/pages/StartingPage';

import Users from './components/modules/users/Users';
import Customers from './components/modules/customers/Customers';
import Settings from './components/modules/settings/Settings';
import ProjectViews from './components/modules/settings/projectViews/ProjectViews';
import ColorsContainer from './components/modules/settings/colorGroups/ColorsContainer';
import Backgrounds from './components/modules/settings/backgrounds/Backgrounds';
import Translations from './components/modules/settings/translations/Translations';
import StoreListContainer from './components/modules/easyFloor/containers/StoreListContainer';
import StoreCreateContainer from './components/modules/easyFloor/containers/StoreCreateContainer';
import StoreMapContainer from './components/modules/easyFloor/containers/StoreMapContainer';
import StorePreview from './components/modules/easyFloor/map/StorePreview';
//import StorePreview from './components/modules/easyFloor/map/StorePreviewV1';
import MapNew from './components/modules/easyFloor/map/MapNew';
import ProjectContainer from './components/modules/easyBoardOnline/view/ProjectContainer';
import ProjectEditor from './components/modules/easyBoardOnline/view/ProjectEditor';
import ProjectEditorV1 from './components/modules/easyBoardOnline/view/ProjectEditorV1';
import ProjectAR from './components/modules/easyBoardOnline/view/ProjectAR';
import ProjectList from './components/modules/easyBoardOnline/list/ProjectList';
import ProjectPublicPreview from './components/modules/easyBoardOnline/public/ProjectPublicPreview';
import ProjectPublicAR from './components/modules/easyBoardOnline/public/ProjectPublicAR';
import ScannedProjectContainer from './components/modules/scannedProjects/view/ScannedProjectContainer';
import ScannedProjectList from './components/modules/scannedProjects/list/ScannedProjectList';

import FloorPlanPublicView from './components/modules/easyFloor/public/FloorPlanPublicView';

import Test from './components/modules/easyBoardOnline/view/Test';
import ScannedProject from './components/modules/scannedProjects/view/ScannedProject';

const loggedInRoutes = () => {
    let routes = [
        { path: 'home', element: <StartingPage /> },
        { path: '*', element: <Navigate to="/404" /> }
    ];

    routes = loadEasyBoardOnlineRoutes(routes);
    routes = loadEasyFloorRoutes(routes);
    routes = loadSettingsRoutes(routes);
    routes = loadUsersRoutes(routes);
    routes = loadCustomersRoutes(routes);
    routes = loadScannedProjectRoutes(routes);

    return routes;  
}

const loadEasyBoardOnlineRoutes = (existingRoutes) => {
    existingRoutes.push({path: 'project', element: <ProjectList />})
    existingRoutes.push({
        path: 'project',
        element: <ProjectContainer />,
        children: [
            {path: 'view/:id', element: <ProjectEditor />},
            {path: 'test/:id', element: <Test />},
            {path: 'view/:id/augmented', element: <ProjectAR />}
        ]
    })

    return existingRoutes;
}

const loadEasyFloorRoutes = (existingRoutes) => {
    existingRoutes.push({path: 'easy-floor', element: <StoreListContainer />})
    existingRoutes.push({path: 'easy-floor/create', element: <StoreCreateContainer type="create"/>})
    existingRoutes.push({path: 'easy-floor/edit/:floorPlanId', element: <StoreCreateContainer type="edit"/>})
    existingRoutes.push(
        {path: 'easy-floor/map', element: <StoreMapContainer />, children: [{path: ':floorPlanId', element: <MapNew /> },
        {path: ':floorPlanId/preview', element: <StorePreview />}]}
    )

    return existingRoutes;
}

const loadSettingsSubRoutes = () => {
    return [
        {path: 'translations', element: <Translations />},
        {path: 'colors', element: <ColorsContainer />},
        {path: 'project-views', element: <ProjectViews />},
        {path: 'backgrounds', element: <Backgrounds />}
    ]
}

const loadSettingsRoutes = (existingRoutes) => {
    existingRoutes.push({
        path: 'settings', element: <Settings />,
        children: loadSettingsSubRoutes()
    })

    return existingRoutes;
}

const loadUsersRoutes = (existingRoutes) => {
    existingRoutes.push({path: 'users', element: <Users />})

    return existingRoutes;
}

const loadCustomersRoutes = (existingRoutes) => {
    existingRoutes.push({path: 'customers', element: <Customers />})

    return existingRoutes;
}

const loadScannedProjectRoutes = (existingRoutes) => {
    existingRoutes.push({path: 'scanned-project', element: <ScannedProjectList />})
    existingRoutes.push({
        path: 'scanned-project',
        element: <ScannedProjectContainer />,
        children: [
            {path: 'view/:id', element: <ScannedProject />},
        ]
    })

    return existingRoutes;
}

const routes = (isLoggedIn) => [
    {
        path: 'app',
        element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
        children: loggedInRoutes()
    },
    {
        path: 'public',
        children: [
            { path: 'project/view/:id', element: <ProjectPublicPreview /> },
            { path: 'project/view/:id/augmented', element: <ProjectPublicAR /> },
            { path: 'easy-floor/view/:id', element: <FloorPlanPublicView type="2D" /> },
            { path: 'easy-floor/view-3d/:id', element: <FloorPlanPublicView type="3D" /> },
            { path: '*', element: <Navigate  to="/404" /> }
        ]
    },
    {
        path: '/',
        element: !isLoggedIn ? <MainLayout /> : <Navigate to="/app/home" />,
        children: [
            { path: 'login', element:  !isLoggedIn ? <Login /> : <Navigate to="/app/home" />},
            { path: '404', element: <NotFound /> },
            { path: '/', element: <Navigate  to="/app/project/view" /> },
            { path: '*', element: <Navigate  to="/404" /> }
        ]
    }
];

export default routes;
